<template>
  <b-container id="testimonials-plans" class="testimonials-plans w-100 mt-5 mb-5" :style="bgColor">
    <h2 v-if="title" class="title-testimonials font-weight-bold text-center mt-5 mb-5">
      {{ title }}
    </h2>
    <div class="carousel-container position-relative">
      <Hooper
        ref="carousel"
        :settings="hooperSettings"
        class="hooper-style h-auto text-center"
        @slide="updateCarousel"
      >
        <Slide v-for="(slide, index) in slides" :key="index" class="pl-5 pr-5 opacity">
          <p v-if="isDefaultTestimonial" class="testimony">{{ $t(slide.testimony) }}</p>
          <prismic-rich-text v-else :field="slide.testimony" class="testimony"></prismic-rich-text>
          <img
            v-if="slide.photo"
            :src="slide.photo"
            :alt="slide.name"
            class="photo"
            loading="lazy"
          />
          <p v-if="slide.name" class="name">{{ slide.name }}</p>
          <p v-if="slide.site" class="text-site">{{ slide.site }}</p>
        </Slide>
      </Hooper>
      <button class="hooper-prev-custom" @click.prevent="slidePrev">
        <Icon class="invert" icon="arrow" color="white" :width="iconSize" :height="iconSize" />
      </button>
      <div class="position-absolute w-100 d-flex align-items-center">
        <ol class="hooper-indicators">
          <li v-for="(slide, index) in slides" :key="index">
            <button
              type="button"
              class="hooper-indicator"
              :class="index + 1 === carouselData ? 'is-active' : ''"
              @click="goToSlide(index + 1)"
            >
              <span class="hooper-sr-only">item {{ index + 1 }}</span>
            </button>
          </li>
        </ol>
      </div>
      <button class="hooper-next-custom" @click.prevent="slideNext">
        <Icon icon="arrow" color="white" :width="iconSize" :height="iconSize" />
      </button>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';
import Icon from 'UI/Icon';

export default {
  name: 'Testimonials',
  components: {
    Hooper,
    Slide,
    Icon
  },
  props: {
    indicatorsColor: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    testimonials: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      carouselData: 1,
      hooperSettings: {
        itemsToShow: 1,
        centerMode: true,
        infiniteScroll: true,
        autoPlay: true,
        wheelControl: false,
        breakpoints: {
          769: {
            itemsToShow: 2
          },
          1200: {
            itemsToShow: 3
          }
        }
      },
      iconSize: 14
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperienceColor']),
    bgColor() {
      return {
        '--bg-color': this.indicatorsColor !== '' ? this.indicatorsColor : this.getExperienceColor
      };
    },
    slides() {
      return this.testimonials.length > 0 ? this.testimonials : this.$g('TESTIMONIALS');
    },
    isDefaultTestimonial() {
      return this.testimonials.length === 0;
    }
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    }
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.carouselData = payload.currentSlide;
    },
    goToSlide(slide) {
      this.carouselData = slide;
    }
  }
};
</script>

<style lang="scss">
#testimonials-plans .hooper-list {
  .is-active {
    opacity: 0.3;
    transition: opacity 0.3s;
  }
  .is-current {
    opacity: 1;
  }
}
</style>

<style lang="scss" scoped>
#testimonials-plans {
  display: flow-root;
}
#testimonials-plans > .title-testimonials {
  color: $strongGray;
  font-size: 20px;
}
.carousel-container {
  margin-bottom: 100px;
}
.hooper-style {
  margin-top: 100px;
}
svg.icon.icon-arrowRight,
svg.icon.icon-arrowLeft {
  fill: #ffffff;
}
.hooper-indicator {
  border-radius: 200%;
  width: 10px;
  height: 10px;
  background-color: #dadada;
}
.hooper-indicators {
  margin: auto;
}
.hooper-indicator:hover,
.hooper-indicator.is-active {
  background-color: var(--bg-color);
}
p.testimony {
  color: $strongGray;
  font-size: 15px;
  margin-bottom: 70px;
}
.photo {
  width: 70px;
  border-radius: 200%;
}
.name {
  color: $strongGray;
  font-size: 18px;
  margin: 15px 0;
}
.text-site {
  color: #999999;
  font-size: 13px;
}
.hooper-next-custom,
.hooper-prev-custom {
  border: none;
  padding: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: var(--bg-color);
  border-radius: 200%;
  height: 35px;
  width: 35px;
  font-size: 25px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  .svg-icon-container {
    position: relative;
  }
}
.hooper-next-custom {
  right: 0;
  .svg-icon-container {
    left: 1px;
  }
}
.hooper-prev-custom {
  left: 0;
  .svg-icon-container {
    right: 1px;
  }
}
</style>
